export enum EBequestTermsStatus {
  REJECTED = 'REJECTED',
  NONE = 'NONE',
  ACCEPTED = 'ACCEPTED',
}
